export default __webpack_public_path__ + "static/media/astronaut.bc9569f3.png";